import Dashboard from "../../components/Users/DashboardMain";

export default function User() {
  return (
      <Dashboard />
  );
}
